export default "__VITE_ASSET__ooJoGTKe__"